<template>
  <div id="app">
      <Header></Header>
      <router-view></router-view>
    <object class="obj-footer" data="/web/Common/snippet/footer.html?json=%7B%22contacts%22%3A%5B%7B%22name%22%3A%22%E5%A4%96%E8%B4%B8%E4%BC%81%E4%B8%9A%E4%BF%A1%E6%81%AF%E7%AE%A1%E7%90%86%22%2C%22value%22%3A%5B%22010-67801607%22%2C%22010-67801960%22%5D%7D%2C%7B%22name%22%3A%22%E5%A4%96%E7%B1%8D%E4%BA%BA%E6%89%8D%E7%B3%BB%E7%BB%9F%22%2C%22value%22%3A%5B%22010-67801607%22%5D%7D%5D%7D"></object>
  </div>
</template>

<script>

import Header from '@/components/Header'

export default {
  data () {
    return {
      // widths: '100%',
      // heights: 'calc(100vh - 336px)'
    }
  },
  created () {
    // window.addEventListener('load', () => {
    //   window.addEventListener('resize', () => {
    //     this.widths = window.innerWidth + 'px'
    //     var h = window.innerHeight - 336
    //     this.heights = h + 'px'
    //   })
    // })
  },
  components: {
    Header
  },
  watch: {
    // 按需加载路由，监听路由变化逻辑处理
    $route (to, from) {
      const _this = this // 这里注意一下记得缓存this
      _this.$router.push({
        path: _this.$route.path, // 这个值我们是可以拿到的
        query: _this.$route.query,
        params: _this.$route.params,
        fullPath: _this.$route.fullPath,
        meta: _this.$route.meta,
        hash: _this.$route.hash,
        matched: _this.$route.matched,
        name: _this.$route.name
      })
    }
  }
}
</script>

<style lang="scss">
@import "../../assets/css/reset.scss";
  .mains{
    overflow: hidden;
    margin: 0 auto;
    width: 1200px;
    background: #fff;
    min-height: calc(100vh - 300px);
  }
</style>
